export default __webpack_public_path__ + "static/media/Watercool-chiller.57de62dd.jpg";